export default "__VITE_ASSET__32701f7f__"